/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Country
 */
export interface Country {
    /**
     * 
     * @type {number}
     * @memberof Country
     */
    readonly id?: number;
    /**
     * 
     * @type {string}
     * @memberof Country
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Country
     */
    iso2: string;
    /**
     * 
     * @type {string}
     * @memberof Country
     */
    iso3: string;
    /**
     * 
     * @type {string}
     * @memberof Country
     */
    timeZone: string;
    /**
     * 
     * @type {string}
     * @memberof Country
     */
    currency: string;
    /**
     * 
     * @type {number}
     * @memberof Country
     */
    vatRate: number;
    /**
     * 
     * @type {string}
     * @memberof Country
     */
    tachoAlpha?: string;
}

export function CountryFromJSON(json: any): Country {
    return CountryFromJSONTyped(json, false);
}

export function CountryFromJSONTyped(json: any, ignoreDiscriminator: boolean): Country {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': json['name'],
        'iso2': json['iso2'],
        'iso3': json['iso3'],
        'timeZone': json['time_zone'],
        'currency': json['currency'],
        'vatRate': json['vat_rate'],
        'tachoAlpha': !exists(json, 'tacho_alpha') ? undefined : json['tacho_alpha'],
    };
}

export function CountryToJSON(value?: Country | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'iso2': value.iso2,
        'iso3': value.iso3,
        'time_zone': value.timeZone,
        'currency': value.currency,
        'vat_rate': value.vatRate,
        'tacho_alpha': value.tachoAlpha,
    };
}


